(ns frontend.ui.page.lp-report-editor.step-3-review.view
  (:require
   [common.localization :as loc]
   [frontend.ui.page.lp-report-editor.common.event :as common-event]
   [frontend.ui.page.lp-report-editor.common.modal.pdf-preview-modal :as pdf-preview-modal]
   [frontend.ui.page.lp-report-editor.common.style :as common-style]
   [frontend.ui.page.lp-report-editor.common.view :as common-view :refer
    [continue-button footer next-button preview-pdf-button]]
   [frontend.ui.page.lp-report-editor.event :as editor-event]
   [frontend.ui.page.lp-report-editor.step-3-review.event :as event]
   [frontend.ui.page.lp-report-editor.step-3-review.sub :as sub]
   [frontend.ui.page.lp-report-editor.sub :as editor-sub]
   [herb.core :refer [<class]]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]))

(defn step-footer
  [selected-report feeder?]
  (let [report @(rf/subscribe [::editor-sub/lp-report])
        wip? @(rf/subscribe [::editor-sub/reports-not-approved?])
        full-access? @(rf/subscribe [::editor-sub/full-access?])]
    [footer
     {:left-content
      [:<>
       [continue-button]
       [:div
        [pdf-preview-modal/view
         {:on-close #(rf/dispatch [::common-event/close-pdf-preview])
          :report   selected-report
          :feeder?  feeder?}]
        [preview-pdf-button
         {:on-click #(rf/dispatch [::common-event/open-pdf-preview selected-report feeder?])}]]
       (when-let [burned-pdfs (seq (:lp-report/burned-pdfs selected-report))]
         [:div
          [button/secondary-hollow
           {:on-click #(rf/dispatch [::editor-event/open-burned-pdf burned-pdfs])}
           (loc/tr :open-burned-pdf)]])]
      :right-content
      [:<>
       (when full-access?
         [:div
          {:class (<class common-style/spacing-left)}
          (if (not= :lp-report.step/review (:lp-report/step report))
            [next-button [::editor-event/activate-step :lp-report.step/pending-approval]]
            [button/primary-solid
             {:disabled? (boolean wip?)
              :on-click  #(rf/dispatch [::event/submit-cycle-for-approval (:db/id report)])}
             (loc/tr :submit-for-approval)])])]}]))

(defn report-preview
  []
  [common-view/report-viewer sub/report-tab-path step-footer])

(defn body
  []
  (fn []
    [report-preview]))
